import { Trans, useLingui } from '@lingui/react/macro';
import { switchUserTournament } from 'modules/auth/store/actions';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { mapPayloadToUpsertInput } from 'modules/organizer/domain/data-mappers/organizer-upsert.data-mapper';
import { Organizer } from 'modules/organizer/domain/interfaces/organizer';
import { OrganizerUpsertPayload } from 'modules/organizer/domain/interfaces/organizer-upsert-payload';
import { upsertOrganizer } from 'modules/organizer/store/organizer/actions';
import { OrganizerForm } from 'modules/organizer/ui/components/organizer-form';
import { useEffect } from 'react';
import UDHeaderTitle from 'ud-ui/components/header-title';
import UDText from 'ud-ui/components/text';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import { useAppDispatch } from 'store/hooks';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';

const OrganizerCreatePage = () => {
  const { t } = useLingui();
  const dispatch = useAppDispatch();
  const dispatchWithToast = useDispatchWithToast();
  const { user } = useAuth();
  const { setHeaderContent } = useMainLayout();
  const initData = { phone: user?.phone } as Organizer;

  const createOrganizer = (data: OrganizerUpsertPayload) => {
    const params = mapPayloadToUpsertInput(data, user!.id);

    dispatchWithToast(upsertOrganizer(params), {
      success: t`Организатор создан`,
      error: t`Не удалось создать организатора. Проверьте данные, возможно, организация с таким названием уже существует`,
    }).then((result) => {
      if (!result) return;

      dispatch(switchUserTournament(result.id));
    });
  };

  useEffect(() => {
    setHeaderContent(
      <UDHeaderTitle>
        <Trans>Создание организатора</Trans>
      </UDHeaderTitle>,
    );
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <>
      <div className="w-full px-6 py-6">
        <UDText type="headline" className="mr-10">
          <Trans>Информация об организаторе</Trans>
        </UDText>
      </div>
      <div className="border-surfacePlatinum20 flex w-full items-center border-b px-6" />
      <div className="w-full px-6 py-6">
        <OrganizerForm onSubmit={createOrganizer} initialValues={initData} />
      </div>
    </>
  );
};

export default OrganizerCreatePage;
